/**
 * Announcement bar discount code copy
 */
(function () {
  const COPIED_LABEL = 'Copied!';
  const DEFAULT_LABEL = 'Copy';
  const RESET_DELAY = 2500;

  function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.announcement-bar--copy-btn');

    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    const code = button.dataset.discountCode;

    if (!code) return;

    const label = button.querySelector('.announcement-bar--copy-btn-label');
    const originalText = label ? label.textContent : DEFAULT_LABEL;

    copyToClipboard(code)
      .then(function () {
        if (label) {
          label.textContent = COPIED_LABEL;
        }

        button.classList.add('is-copied');
        button.disabled = true;

        window.setTimeout(function () {
          if (label) {
            label.textContent = originalText;
          }

          button.classList.remove('is-copied');
          button.disabled = false;
        }, RESET_DELAY);
      })
      .catch(function () {
        if (label) {
          label.textContent = 'Failed';
        }

        window.setTimeout(function () {
          if (label) {
            label.textContent = originalText;
          }
        }, RESET_DELAY);
      });
  });
})();
